import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { AGENCY_UPDATE_B2B, AGENCY_SESSION, STATIC_DOMAIN_LOGO, IMAGES_URL } from "./urls_b2b";

@Injectable()
export class AgencyDashboardService {
	constructor(private baseService: BaseService) {}

	getAgency() {
		return this.baseService.tokenGetRequest(AGENCY_SESSION);
	}

	updateAgency(agency) {
		return this.baseService.tokenPutRequest(AGENCY_UPDATE_B2B, agency);
	}

	deleteAgencyLogo(path: string) {
		return this.baseService.tokenDeleteRequest(`${IMAGES_URL}/${path}`);
	}
	updateAgencyLogo(formData) {
		return this.baseService.tokenPostRequest(STATIC_DOMAIN_LOGO, formData);
	}
	
}
